var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/PaginatedList.ts";
import * as t from 'io-ts';
export var PaginatedList = function PaginatedList(item) {
  return t["interface"]({
    list: t.array(item),
    total: t.number
  });
};